/* eslint-disable */ // @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './routes/__root';
import { Route as ProfileRouteImport } from './routes/profile';
import { Route as LoginRouteImport } from './routes/login';
import { Route as R403RouteImport } from './routes/403';
import { Route as OrgRouteRouteImport } from './routes/org/route';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ProfileIndexRouteImport } from './routes/profile/index';
import { Route as AuthCallbackRouteImport } from './routes/auth/callback';
import { Route as OrgOrganizationRouteRouteImport } from './routes/org/$organization/route';
import { Route as ProfileSettingsIndexRouteImport } from './routes/profile/settings/index';
import { Route as ProfileUsernameIndexRouteImport } from './routes/profile/$username/index';
import { Route as OrgOrganizationIndexRouteImport } from './routes/org/$organization/index';
import { Route as ProfileSettingsEmailSettingsRouteImport } from './routes/profile/settings/email-settings';
import { Route as OrgOrganizationManagedApplicationsRouteImport } from './routes/org/$organization/managed-applications';
import { Route as OrgOrganizationUnmanagedApplicationsRouteRouteImport } from './routes/org/$organization/unmanaged-applications/route';
import { Route as OrgOrganizationSettingsRouteRouteImport } from './routes/org/$organization/settings/route';
import { Route as OrgOrganizationProjectsRouteRouteImport } from './routes/org/$organization/projects/route';
import { Route as OrgOrganizationProjectRouteRouteImport } from './routes/org/$organization/$project/route';
import { Route as ProfileSettingsUserTokensIndexRouteImport } from './routes/profile/settings/user-tokens/index';
import { Route as OrgOrganizationUnmanagedApplicationsIndexRouteImport } from './routes/org/$organization/unmanaged-applications/index';
import { Route as OrgOrganizationSettingsIndexRouteImport } from './routes/org/$organization/settings/index';
import { Route as OrgOrganizationProjectIndexRouteImport } from './routes/org/$organization/$project/index';
import { Route as ProfileSettingsUserTokensGenerateRouteImport } from './routes/profile/settings/user-tokens/generate';
import { Route as ProfileSettingsUserTokensUsertokenRouteImport } from './routes/profile/settings/user-tokens/$usertoken';
import { Route as OrgOrganizationUnmanagedApplicationsNewRouteImport } from './routes/org/$organization/unmanaged-applications/new';
import { Route as OrgOrganizationUnmanagedApplicationsApplicationRouteImport } from './routes/org/$organization/unmanaged-applications/$application';
import { Route as OrgOrganizationSettingsPeopleRouteImport } from './routes/org/$organization/settings/people';
import { Route as OrgOrganizationSettingsMembershipRouteImport } from './routes/org/$organization/settings/membership';
import { Route as OrgOrganizationSettingsAuditLogRouteImport } from './routes/org/$organization/settings/audit-log';
import { Route as OrgOrganizationSettingsTeamsRouteRouteImport } from './routes/org/$organization/settings/teams/route';
import { Route as OrgOrganizationSettingsSubscriptionRouteRouteImport } from './routes/org/$organization/settings/subscription/route';
import { Route as OrgOrganizationSettingsServerTokensRouteRouteImport } from './routes/org/$organization/settings/server-tokens/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsRouteRouteImport } from './routes/org/$organization/settings/deployment-integrations/route';
import { Route as OrgOrganizationProjectSettingsRouteRouteImport } from './routes/org/$organization/$project/settings/route';
import { Route as OrgOrganizationProjectApplicationsRouteRouteImport } from './routes/org/$organization/$project/applications/route';
import { Route as OrgOrganizationProjectApplicationRouteRouteImport } from './routes/org/$organization/$project/$application/route';
import { Route as OrgOrganizationSettingsTeamsIndexRouteImport } from './routes/org/$organization/settings/teams/index';
import { Route as OrgOrganizationSettingsSubscriptionIndexRouteImport } from './routes/org/$organization/settings/subscription/index';
import { Route as OrgOrganizationSettingsServerTokensIndexRouteImport } from './routes/org/$organization/settings/server-tokens/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/index';
import { Route as OrgOrganizationProjectApplicationsIndexRouteImport } from './routes/org/$organization/$project/applications/index';
import { Route as OrgOrganizationProjectApplicationIndexRouteImport } from './routes/org/$organization/$project/$application/index';
import { Route as OrgOrganizationSettingsTeamsTeamRouteImport } from './routes/org/$organization/settings/teams/$team';
import { Route as OrgOrganizationSettingsSubscriptionManageRouteImport } from './routes/org/$organization/settings/subscription/manage';
import { Route as OrgOrganizationSettingsServerTokensNewRouteImport } from './routes/org/$organization/settings/server-tokens/new';
import { Route as OrgOrganizationSettingsServerTokensTokenRouteImport } from './routes/org/$organization/settings/server-tokens/$token';
import { Route as OrgOrganizationProjectSettingsGeneralRouteImport } from './routes/org/$organization/$project/settings/general';
import { Route as OrgOrganizationProjectSettingsCollaborationsTeamsRouteImport } from './routes/org/$organization/$project/settings/collaborations-teams';
import { Route as OrgOrganizationProjectDevopsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/devops/deployment-integrations';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/route';
import { Route as OrgOrganizationProjectApplicationVersionsRouteRouteImport } from './routes/org/$organization/$project/$application/versions/route';
import { Route as OrgOrganizationProjectApplicationSettingsRouteRouteImport } from './routes/org/$organization/$project/$application/settings/route';
import { Route as OrgOrganizationProjectApplicationDevopsRouteRouteImport } from './routes/org/$organization/$project/$application/devops/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/index';
import { Route as OrgOrganizationProjectApplicationVersionsIndexRouteImport } from './routes/org/$organization/$project/$application/versions/index';
import { Route as OrgOrganizationProjectApplicationUmlIndexRouteImport } from './routes/org/$organization/$project/$application/uml/index';
import { Route as OrgOrganizationProjectApplicationSettingsIndexRouteImport } from './routes/org/$organization/$project/$application/settings/index';
import { Route as OrgOrganizationProjectApplicationRemotesIndexRouteImport } from './routes/org/$organization/$project/$application/remotes/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/add';
import { Route as OrgOrganizationProjectApplicationVersionsVersionidRouteImport } from './routes/org/$organization/$project/$application/versions/$versionid';
import { Route as OrgOrganizationProjectApplicationSettingsGeneralRouteImport } from './routes/org/$organization/$project/$application/settings/general';
import { Route as OrgOrganizationProjectApplicationSettingsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/$application/settings/deployment-integrations';
import { Route as OrgOrganizationProjectApplicationSettingsCollaboratorsRouteImport } from './routes/org/$organization/$project/$application/settings/collaborators';
import { Route as OrgOrganizationProjectApplicationDevopsDeploymentIntegrationsRouteImport } from './routes/org/$organization/$project/$application/devops/deployment-integrations';
import { Route as OrgOrganizationProjectApplicationSettingsContributorListRouteRouteImport } from './routes/org/$organization/$project/$application/settings/contributor-list/route';
import { Route as OrgOrganizationProjectApplicationDevopsTagsRouteRouteImport } from './routes/org/$organization/$project/$application/devops/tags/route';
import { Route as OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteImport } from './routes/org/$organization/$project/$application/devops/release-pipeline-board/route';
import { Route as OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteImport } from './routes/org/$organization/$project/$application/devops/release-pipeline/route';
import { Route as OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteImport } from './routes/org/$organization/$project/$application/devops/environment/route';
import { Route as OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteImport } from './routes/org/$organization/$project/$application/analytics/dependencies/route';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/index';
import { Route as OrgOrganizationProjectApplicationModuleModuleIndexRouteImport } from './routes/org/$organization/$project/$application/module/$module/index';
import { Route as OrgOrganizationProjectApplicationDevopsTagsIndexRouteImport } from './routes/org/$organization/$project/$application/devops/tags/index';
import { Route as OrgOrganizationProjectApplicationDevopsReleasePipelineIndexRouteImport } from './routes/org/$organization/$project/$application/devops/release-pipeline/index';
import { Route as OrgOrganizationProjectApplicationDevopsReleasePipelineBoardIndexRouteImport } from './routes/org/$organization/$project/$application/devops/release-pipeline-board/index';
import { Route as OrgOrganizationProjectApplicationDevopsEnvironmentIndexRouteImport } from './routes/org/$organization/$project/$application/devops/environment/index';
import { Route as OrgOrganizationProjectApplicationDevopsDeploymentRollbackIndexRouteImport } from './routes/org/$organization/$project/$application/devops/deployment-rollback/index';
import { Route as OrgOrganizationProjectApplicationAnalyticsNodeGraphIndexRouteImport } from './routes/org/$organization/$project/$application/analytics/node-graph/index';
import { Route as OrgOrganizationProjectApplicationAnalyticsDependencyGraphIndexRouteImport } from './routes/org/$organization/$project/$application/analytics/dependency-graph/index';
import { Route as OrgOrganizationProjectApplicationAnalyticsDependenciesIndexRouteImport } from './routes/org/$organization/$project/$application/analytics/dependencies/index';
import { Route as OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRouteImport } from './routes/org/$organization/settings/deployment-integrations/$integrationType/$integrationName/edit';
import { Route as OrgOrganizationProjectApplicationDevopsTagsAddRouteImport } from './routes/org/$organization/$project/$application/devops/tags/add';
import { Route as OrgOrganizationProjectApplicationDevopsTagsTagRouteImport } from './routes/org/$organization/$project/$application/devops/tags/$tag';
import { Route as OrgOrganizationProjectApplicationDevopsEnvironmentAddRouteImport } from './routes/org/$organization/$project/$application/devops/environment/add';
import { Route as OrgOrganizationProjectApplicationDevopsEnvironmentEnvironmentRouteImport } from './routes/org/$organization/$project/$application/devops/environment/$environment';
import { Route as OrgOrganizationProjectApplicationAnalyticsNodeApplicationIdDependenciesIndexRouteImport } from './routes/org/$organization/$project/$application/analytics/node/$applicationId/dependencies/index';
const ProfileRoute = ProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: ()=>rootRouteImport
});
const LoginRoute = LoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: ()=>rootRouteImport
});
const R403Route = R403RouteImport.update({
    id: '/403',
    path: '/403',
    getParentRoute: ()=>rootRouteImport
});
const OrgRouteRoute = OrgRouteRouteImport.update({
    id: '/org',
    path: '/org',
    getParentRoute: ()=>rootRouteImport
});
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>rootRouteImport
});
const ProfileIndexRoute = ProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>ProfileRoute
});
const AuthCallbackRoute = AuthCallbackRouteImport.update({
    id: '/auth/callback',
    path: '/auth/callback',
    getParentRoute: ()=>rootRouteImport
});
const OrgOrganizationRouteRoute = OrgOrganizationRouteRouteImport.update({
    id: '/$organization',
    path: '/$organization',
    getParentRoute: ()=>OrgRouteRoute
});
const ProfileSettingsIndexRoute = ProfileSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: ()=>ProfileRoute
});
const ProfileUsernameIndexRoute = ProfileUsernameIndexRouteImport.update({
    id: '/$username/',
    path: '/$username/',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationIndexRoute = OrgOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const ProfileSettingsEmailSettingsRoute = ProfileSettingsEmailSettingsRouteImport.update({
    id: '/settings/email-settings',
    path: '/settings/email-settings',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationManagedApplicationsRoute = OrgOrganizationManagedApplicationsRouteImport.update({
    id: '/managed-applications',
    path: '/managed-applications',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationUnmanagedApplicationsRouteRoute = OrgOrganizationUnmanagedApplicationsRouteRouteImport.update({
    id: '/unmanaged-applications',
    path: '/unmanaged-applications',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationSettingsRouteRoute = OrgOrganizationSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationProjectsRouteRoute = OrgOrganizationProjectsRouteRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const OrgOrganizationProjectRouteRoute = OrgOrganizationProjectRouteRouteImport.update({
    id: '/$project',
    path: '/$project',
    getParentRoute: ()=>OrgOrganizationRouteRoute
});
const ProfileSettingsUserTokensIndexRoute = ProfileSettingsUserTokensIndexRouteImport.update({
    id: '/settings/user-tokens/',
    path: '/settings/user-tokens/',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationUnmanagedApplicationsIndexRoute = OrgOrganizationUnmanagedApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationUnmanagedApplicationsRouteRoute
});
const OrgOrganizationSettingsIndexRoute = OrgOrganizationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationProjectIndexRoute = OrgOrganizationProjectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const ProfileSettingsUserTokensGenerateRoute = ProfileSettingsUserTokensGenerateRouteImport.update({
    id: '/settings/user-tokens/generate',
    path: '/settings/user-tokens/generate',
    getParentRoute: ()=>ProfileRoute
});
const ProfileSettingsUserTokensUsertokenRoute = ProfileSettingsUserTokensUsertokenRouteImport.update({
    id: '/settings/user-tokens/$usertoken',
    path: '/settings/user-tokens/$usertoken',
    getParentRoute: ()=>ProfileRoute
});
const OrgOrganizationUnmanagedApplicationsNewRoute = OrgOrganizationUnmanagedApplicationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: ()=>OrgOrganizationUnmanagedApplicationsRouteRoute
});
const OrgOrganizationUnmanagedApplicationsApplicationRoute = OrgOrganizationUnmanagedApplicationsApplicationRouteImport.update({
    id: '/$application',
    path: '/$application',
    getParentRoute: ()=>OrgOrganizationUnmanagedApplicationsRouteRoute
});
const OrgOrganizationSettingsPeopleRoute = OrgOrganizationSettingsPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsMembershipRoute = OrgOrganizationSettingsMembershipRouteImport.update({
    id: '/membership',
    path: '/membership',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsAuditLogRoute = OrgOrganizationSettingsAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsTeamsRouteRoute = OrgOrganizationSettingsTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsSubscriptionRouteRoute = OrgOrganizationSettingsSubscriptionRouteRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsServerTokensRouteRoute = OrgOrganizationSettingsServerTokensRouteRouteImport.update({
    id: '/server-tokens',
    path: '/server-tokens',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsRouteRoute = OrgOrganizationSettingsDeploymentIntegrationsRouteRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationSettingsRouteRoute
});
const OrgOrganizationProjectSettingsRouteRoute = OrgOrganizationProjectSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationProjectApplicationsRouteRoute = OrgOrganizationProjectApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationProjectApplicationRouteRoute = OrgOrganizationProjectApplicationRouteRouteImport.update({
    id: '/$application',
    path: '/$application',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationSettingsTeamsIndexRoute = OrgOrganizationSettingsTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsTeamsRouteRoute
});
const OrgOrganizationSettingsSubscriptionIndexRoute = OrgOrganizationSettingsSubscriptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsSubscriptionRouteRoute
});
const OrgOrganizationSettingsServerTokensIndexRoute = OrgOrganizationSettingsServerTokensIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsRouteRoute
});
const OrgOrganizationProjectApplicationsIndexRoute = OrgOrganizationProjectApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationsRouteRoute
});
const OrgOrganizationProjectApplicationIndexRoute = OrgOrganizationProjectApplicationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationSettingsTeamsTeamRoute = OrgOrganizationSettingsTeamsTeamRouteImport.update({
    id: '/$team',
    path: '/$team',
    getParentRoute: ()=>OrgOrganizationSettingsTeamsRouteRoute
});
const OrgOrganizationSettingsSubscriptionManageRoute = OrgOrganizationSettingsSubscriptionManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: ()=>OrgOrganizationSettingsSubscriptionRouteRoute
});
const OrgOrganizationSettingsServerTokensNewRoute = OrgOrganizationSettingsServerTokensNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationSettingsServerTokensTokenRoute = OrgOrganizationSettingsServerTokensTokenRouteImport.update({
    id: '/$token',
    path: '/$token',
    getParentRoute: ()=>OrgOrganizationSettingsServerTokensRouteRoute
});
const OrgOrganizationProjectSettingsGeneralRoute = OrgOrganizationProjectSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: ()=>OrgOrganizationProjectSettingsRouteRoute
});
const OrgOrganizationProjectSettingsCollaborationsTeamsRoute = OrgOrganizationProjectSettingsCollaborationsTeamsRouteImport.update({
    id: '/collaborations-teams',
    path: '/collaborations-teams',
    getParentRoute: ()=>OrgOrganizationProjectSettingsRouteRoute
});
const OrgOrganizationProjectDevopsDeploymentIntegrationsRoute = OrgOrganizationProjectDevopsDeploymentIntegrationsRouteImport.update({
    id: '/devops/deployment-integrations',
    path: '/devops/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteImport.update({
    id: '/$integrationType',
    path: '/$integrationType',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsRouteRoute
});
const OrgOrganizationProjectApplicationVersionsRouteRoute = OrgOrganizationProjectApplicationVersionsRouteRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationSettingsRouteRoute = OrgOrganizationProjectApplicationSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationDevopsRouteRoute = OrgOrganizationProjectApplicationDevopsRouteRouteImport.update({
    id: '/devops',
    path: '/devops',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectApplicationVersionsIndexRoute = OrgOrganizationProjectApplicationVersionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationVersionsRouteRoute
});
const OrgOrganizationProjectApplicationUmlIndexRoute = OrgOrganizationProjectApplicationUmlIndexRouteImport.update({
    id: '/uml/',
    path: '/uml/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationSettingsIndexRoute = OrgOrganizationProjectApplicationSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationSettingsRouteRoute
});
const OrgOrganizationProjectApplicationRemotesIndexRoute = OrgOrganizationProjectApplicationRemotesIndexRouteImport.update({
    id: '/remotes/',
    path: '/remotes/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectApplicationVersionsVersionidRoute = OrgOrganizationProjectApplicationVersionsVersionidRouteImport.update({
    id: '/$versionid',
    path: '/$versionid',
    getParentRoute: ()=>OrgOrganizationProjectApplicationVersionsRouteRoute
});
const OrgOrganizationProjectApplicationSettingsGeneralRoute = OrgOrganizationProjectApplicationSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: ()=>OrgOrganizationProjectApplicationSettingsRouteRoute
});
const OrgOrganizationProjectApplicationSettingsDeploymentIntegrationsRoute = OrgOrganizationProjectApplicationSettingsDeploymentIntegrationsRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectApplicationSettingsRouteRoute
});
const OrgOrganizationProjectApplicationSettingsCollaboratorsRoute = OrgOrganizationProjectApplicationSettingsCollaboratorsRouteImport.update({
    id: '/collaborators',
    path: '/collaborators',
    getParentRoute: ()=>OrgOrganizationProjectApplicationSettingsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsDeploymentIntegrationsRoute = OrgOrganizationProjectApplicationDevopsDeploymentIntegrationsRouteImport.update({
    id: '/deployment-integrations',
    path: '/deployment-integrations',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationSettingsContributorListRouteRoute = OrgOrganizationProjectApplicationSettingsContributorListRouteRouteImport.update({
    id: '/contributor-list',
    path: '/contributor-list',
    getParentRoute: ()=>OrgOrganizationProjectApplicationSettingsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsTagsRouteRoute = OrgOrganizationProjectApplicationDevopsTagsRouteRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRoute = OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteImport.update({
    id: '/release-pipeline-board',
    path: '/release-pipeline-board',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRoute = OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteImport.update({
    id: '/release-pipeline',
    path: '/release-pipeline',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute = OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteImport.update({
    id: '/environment',
    path: '/environment',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRoute = OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteImport.update({
    id: '/analytics/dependencies',
    path: '/analytics/dependencies',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRouteImport.update({
    id: '/$integrationName/',
    path: '/$integrationName/',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectApplicationModuleModuleIndexRoute = OrgOrganizationProjectApplicationModuleModuleIndexRouteImport.update({
    id: '/module/$module/',
    path: '/module/$module/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationDevopsTagsIndexRoute = OrgOrganizationProjectApplicationDevopsTagsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsReleasePipelineIndexRoute = OrgOrganizationProjectApplicationDevopsReleasePipelineIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRoute
});
const OrgOrganizationProjectApplicationDevopsReleasePipelineBoardIndexRoute = OrgOrganizationProjectApplicationDevopsReleasePipelineBoardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRoute
});
const OrgOrganizationProjectApplicationDevopsEnvironmentIndexRoute = OrgOrganizationProjectApplicationDevopsEnvironmentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectApplicationDevopsDeploymentRollbackIndexRoute = OrgOrganizationProjectApplicationDevopsDeploymentRollbackIndexRouteImport.update({
    id: '/deployment-rollback/',
    path: '/deployment-rollback/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsRouteRoute
});
const OrgOrganizationProjectApplicationAnalyticsNodeGraphIndexRoute = OrgOrganizationProjectApplicationAnalyticsNodeGraphIndexRouteImport.update({
    id: '/analytics/node-graph/',
    path: '/analytics/node-graph/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationAnalyticsDependencyGraphIndexRoute = OrgOrganizationProjectApplicationAnalyticsDependencyGraphIndexRouteImport.update({
    id: '/analytics/dependency-graph/',
    path: '/analytics/dependency-graph/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationAnalyticsDependenciesIndexRoute = OrgOrganizationProjectApplicationAnalyticsDependenciesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRoute
});
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRouteImport.update({
    id: '/$integrationName/edit',
    path: '/$integrationName/edit',
    getParentRoute: ()=>OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute
});
const OrgOrganizationProjectApplicationDevopsTagsAddRoute = OrgOrganizationProjectApplicationDevopsTagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsTagsTagRoute = OrgOrganizationProjectApplicationDevopsTagsTagRouteImport.update({
    id: '/$tag',
    path: '/$tag',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsTagsRouteRoute
});
const OrgOrganizationProjectApplicationDevopsEnvironmentAddRoute = OrgOrganizationProjectApplicationDevopsEnvironmentAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectApplicationDevopsEnvironmentEnvironmentRoute = OrgOrganizationProjectApplicationDevopsEnvironmentEnvironmentRouteImport.update({
    id: '/$environment',
    path: '/$environment',
    getParentRoute: ()=>OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute
});
const OrgOrganizationProjectApplicationAnalyticsNodeApplicationIdDependenciesIndexRoute = OrgOrganizationProjectApplicationAnalyticsNodeApplicationIdDependenciesIndexRouteImport.update({
    id: '/analytics/node/$applicationId/dependencies/',
    path: '/analytics/node/$applicationId/dependencies/',
    getParentRoute: ()=>OrgOrganizationProjectApplicationRouteRoute
});
const OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsEnvironmentEnvironmentRoute: OrgOrganizationProjectApplicationDevopsEnvironmentEnvironmentRoute,
    OrgOrganizationProjectApplicationDevopsEnvironmentAddRoute: OrgOrganizationProjectApplicationDevopsEnvironmentAddRoute,
    OrgOrganizationProjectApplicationDevopsEnvironmentIndexRoute: OrgOrganizationProjectApplicationDevopsEnvironmentIndexRoute
};
const OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteWithChildren = OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute._addFileChildren(OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteChildren);
const OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsReleasePipelineIndexRoute: OrgOrganizationProjectApplicationDevopsReleasePipelineIndexRoute
};
const OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteWithChildren = OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRoute._addFileChildren(OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteChildren);
const OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsReleasePipelineBoardIndexRoute: OrgOrganizationProjectApplicationDevopsReleasePipelineBoardIndexRoute
};
const OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteWithChildren = OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRoute._addFileChildren(OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteChildren);
const OrgOrganizationProjectApplicationDevopsTagsRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsTagsTagRoute: OrgOrganizationProjectApplicationDevopsTagsTagRoute,
    OrgOrganizationProjectApplicationDevopsTagsAddRoute: OrgOrganizationProjectApplicationDevopsTagsAddRoute,
    OrgOrganizationProjectApplicationDevopsTagsIndexRoute: OrgOrganizationProjectApplicationDevopsTagsIndexRoute
};
const OrgOrganizationProjectApplicationDevopsTagsRouteRouteWithChildren = OrgOrganizationProjectApplicationDevopsTagsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationDevopsTagsRouteRouteChildren);
const OrgOrganizationProjectApplicationDevopsRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsEnvironmentRouteRoute: OrgOrganizationProjectApplicationDevopsEnvironmentRouteRouteWithChildren,
    OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRoute: OrgOrganizationProjectApplicationDevopsReleasePipelineRouteRouteWithChildren,
    OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRoute: OrgOrganizationProjectApplicationDevopsReleasePipelineBoardRouteRouteWithChildren,
    OrgOrganizationProjectApplicationDevopsTagsRouteRoute: OrgOrganizationProjectApplicationDevopsTagsRouteRouteWithChildren,
    OrgOrganizationProjectApplicationDevopsDeploymentIntegrationsRoute: OrgOrganizationProjectApplicationDevopsDeploymentIntegrationsRoute,
    OrgOrganizationProjectApplicationDevopsDeploymentRollbackIndexRoute: OrgOrganizationProjectApplicationDevopsDeploymentRollbackIndexRoute
};
const OrgOrganizationProjectApplicationDevopsRouteRouteWithChildren = OrgOrganizationProjectApplicationDevopsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationDevopsRouteRouteChildren);
const OrgOrganizationProjectApplicationSettingsRouteRouteChildren = {
    OrgOrganizationProjectApplicationSettingsContributorListRouteRoute: OrgOrganizationProjectApplicationSettingsContributorListRouteRoute,
    OrgOrganizationProjectApplicationSettingsCollaboratorsRoute: OrgOrganizationProjectApplicationSettingsCollaboratorsRoute,
    OrgOrganizationProjectApplicationSettingsDeploymentIntegrationsRoute: OrgOrganizationProjectApplicationSettingsDeploymentIntegrationsRoute,
    OrgOrganizationProjectApplicationSettingsGeneralRoute: OrgOrganizationProjectApplicationSettingsGeneralRoute,
    OrgOrganizationProjectApplicationSettingsIndexRoute: OrgOrganizationProjectApplicationSettingsIndexRoute
};
const OrgOrganizationProjectApplicationSettingsRouteRouteWithChildren = OrgOrganizationProjectApplicationSettingsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationSettingsRouteRouteChildren);
const OrgOrganizationProjectApplicationVersionsRouteRouteChildren = {
    OrgOrganizationProjectApplicationVersionsVersionidRoute: OrgOrganizationProjectApplicationVersionsVersionidRoute,
    OrgOrganizationProjectApplicationVersionsIndexRoute: OrgOrganizationProjectApplicationVersionsIndexRoute
};
const OrgOrganizationProjectApplicationVersionsRouteRouteWithChildren = OrgOrganizationProjectApplicationVersionsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationVersionsRouteRouteChildren);
const OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteChildren = {
    OrgOrganizationProjectApplicationAnalyticsDependenciesIndexRoute: OrgOrganizationProjectApplicationAnalyticsDependenciesIndexRoute
};
const OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteWithChildren = OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRoute._addFileChildren(OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteChildren);
const OrgOrganizationProjectApplicationRouteRouteChildren = {
    OrgOrganizationProjectApplicationDevopsRouteRoute: OrgOrganizationProjectApplicationDevopsRouteRouteWithChildren,
    OrgOrganizationProjectApplicationSettingsRouteRoute: OrgOrganizationProjectApplicationSettingsRouteRouteWithChildren,
    OrgOrganizationProjectApplicationVersionsRouteRoute: OrgOrganizationProjectApplicationVersionsRouteRouteWithChildren,
    OrgOrganizationProjectApplicationIndexRoute: OrgOrganizationProjectApplicationIndexRoute,
    OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRoute: OrgOrganizationProjectApplicationAnalyticsDependenciesRouteRouteWithChildren,
    OrgOrganizationProjectApplicationRemotesIndexRoute: OrgOrganizationProjectApplicationRemotesIndexRoute,
    OrgOrganizationProjectApplicationUmlIndexRoute: OrgOrganizationProjectApplicationUmlIndexRoute,
    OrgOrganizationProjectApplicationAnalyticsDependencyGraphIndexRoute: OrgOrganizationProjectApplicationAnalyticsDependencyGraphIndexRoute,
    OrgOrganizationProjectApplicationAnalyticsNodeGraphIndexRoute: OrgOrganizationProjectApplicationAnalyticsNodeGraphIndexRoute,
    OrgOrganizationProjectApplicationModuleModuleIndexRoute: OrgOrganizationProjectApplicationModuleModuleIndexRoute,
    OrgOrganizationProjectApplicationAnalyticsNodeApplicationIdDependenciesIndexRoute: OrgOrganizationProjectApplicationAnalyticsNodeApplicationIdDependenciesIndexRoute
};
const OrgOrganizationProjectApplicationRouteRouteWithChildren = OrgOrganizationProjectApplicationRouteRoute._addFileChildren(OrgOrganizationProjectApplicationRouteRouteChildren);
const OrgOrganizationProjectApplicationsRouteRouteChildren = {
    OrgOrganizationProjectApplicationsIndexRoute: OrgOrganizationProjectApplicationsIndexRoute
};
const OrgOrganizationProjectApplicationsRouteRouteWithChildren = OrgOrganizationProjectApplicationsRouteRoute._addFileChildren(OrgOrganizationProjectApplicationsRouteRouteChildren);
const OrgOrganizationProjectSettingsRouteRouteChildren = {
    OrgOrganizationProjectSettingsCollaborationsTeamsRoute: OrgOrganizationProjectSettingsCollaborationsTeamsRoute,
    OrgOrganizationProjectSettingsGeneralRoute: OrgOrganizationProjectSettingsGeneralRoute
};
const OrgOrganizationProjectSettingsRouteRouteWithChildren = OrgOrganizationProjectSettingsRouteRoute._addFileChildren(OrgOrganizationProjectSettingsRouteRouteChildren);
const OrgOrganizationProjectRouteRouteChildren = {
    OrgOrganizationProjectApplicationRouteRoute: OrgOrganizationProjectApplicationRouteRouteWithChildren,
    OrgOrganizationProjectApplicationsRouteRoute: OrgOrganizationProjectApplicationsRouteRouteWithChildren,
    OrgOrganizationProjectSettingsRouteRoute: OrgOrganizationProjectSettingsRouteRouteWithChildren,
    OrgOrganizationProjectIndexRoute: OrgOrganizationProjectIndexRoute,
    OrgOrganizationProjectDevopsDeploymentIntegrationsRoute: OrgOrganizationProjectDevopsDeploymentIntegrationsRoute
};
const OrgOrganizationProjectRouteRouteWithChildren = OrgOrganizationProjectRouteRoute._addFileChildren(OrgOrganizationProjectRouteRouteChildren);
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeAddRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIndexRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameEditRoute,
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeIntegrationNameIndexRoute
};
const OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteWithChildren = OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute._addFileChildren(OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteChildren);
const OrgOrganizationSettingsDeploymentIntegrationsRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRoute: OrgOrganizationSettingsDeploymentIntegrationsIntegrationTypeRouteRouteWithChildren,
    OrgOrganizationSettingsDeploymentIntegrationsIndexRoute: OrgOrganizationSettingsDeploymentIntegrationsIndexRoute
};
const OrgOrganizationSettingsDeploymentIntegrationsRouteRouteWithChildren = OrgOrganizationSettingsDeploymentIntegrationsRouteRoute._addFileChildren(OrgOrganizationSettingsDeploymentIntegrationsRouteRouteChildren);
const OrgOrganizationSettingsServerTokensRouteRouteChildren = {
    OrgOrganizationSettingsServerTokensTokenRoute: OrgOrganizationSettingsServerTokensTokenRoute,
    OrgOrganizationSettingsServerTokensNewRoute: OrgOrganizationSettingsServerTokensNewRoute,
    OrgOrganizationSettingsServerTokensIndexRoute: OrgOrganizationSettingsServerTokensIndexRoute
};
const OrgOrganizationSettingsServerTokensRouteRouteWithChildren = OrgOrganizationSettingsServerTokensRouteRoute._addFileChildren(OrgOrganizationSettingsServerTokensRouteRouteChildren);
const OrgOrganizationSettingsSubscriptionRouteRouteChildren = {
    OrgOrganizationSettingsSubscriptionManageRoute: OrgOrganizationSettingsSubscriptionManageRoute,
    OrgOrganizationSettingsSubscriptionIndexRoute: OrgOrganizationSettingsSubscriptionIndexRoute
};
const OrgOrganizationSettingsSubscriptionRouteRouteWithChildren = OrgOrganizationSettingsSubscriptionRouteRoute._addFileChildren(OrgOrganizationSettingsSubscriptionRouteRouteChildren);
const OrgOrganizationSettingsTeamsRouteRouteChildren = {
    OrgOrganizationSettingsTeamsTeamRoute: OrgOrganizationSettingsTeamsTeamRoute,
    OrgOrganizationSettingsTeamsIndexRoute: OrgOrganizationSettingsTeamsIndexRoute
};
const OrgOrganizationSettingsTeamsRouteRouteWithChildren = OrgOrganizationSettingsTeamsRouteRoute._addFileChildren(OrgOrganizationSettingsTeamsRouteRouteChildren);
const OrgOrganizationSettingsRouteRouteChildren = {
    OrgOrganizationSettingsDeploymentIntegrationsRouteRoute: OrgOrganizationSettingsDeploymentIntegrationsRouteRouteWithChildren,
    OrgOrganizationSettingsServerTokensRouteRoute: OrgOrganizationSettingsServerTokensRouteRouteWithChildren,
    OrgOrganizationSettingsSubscriptionRouteRoute: OrgOrganizationSettingsSubscriptionRouteRouteWithChildren,
    OrgOrganizationSettingsTeamsRouteRoute: OrgOrganizationSettingsTeamsRouteRouteWithChildren,
    OrgOrganizationSettingsAuditLogRoute: OrgOrganizationSettingsAuditLogRoute,
    OrgOrganizationSettingsMembershipRoute: OrgOrganizationSettingsMembershipRoute,
    OrgOrganizationSettingsPeopleRoute: OrgOrganizationSettingsPeopleRoute,
    OrgOrganizationSettingsIndexRoute: OrgOrganizationSettingsIndexRoute
};
const OrgOrganizationSettingsRouteRouteWithChildren = OrgOrganizationSettingsRouteRoute._addFileChildren(OrgOrganizationSettingsRouteRouteChildren);
const OrgOrganizationUnmanagedApplicationsRouteRouteChildren = {
    OrgOrganizationUnmanagedApplicationsApplicationRoute: OrgOrganizationUnmanagedApplicationsApplicationRoute,
    OrgOrganizationUnmanagedApplicationsNewRoute: OrgOrganizationUnmanagedApplicationsNewRoute,
    OrgOrganizationUnmanagedApplicationsIndexRoute: OrgOrganizationUnmanagedApplicationsIndexRoute
};
const OrgOrganizationUnmanagedApplicationsRouteRouteWithChildren = OrgOrganizationUnmanagedApplicationsRouteRoute._addFileChildren(OrgOrganizationUnmanagedApplicationsRouteRouteChildren);
const OrgOrganizationRouteRouteChildren = {
    OrgOrganizationProjectRouteRoute: OrgOrganizationProjectRouteRouteWithChildren,
    OrgOrganizationProjectsRouteRoute: OrgOrganizationProjectsRouteRoute,
    OrgOrganizationSettingsRouteRoute: OrgOrganizationSettingsRouteRouteWithChildren,
    OrgOrganizationUnmanagedApplicationsRouteRoute: OrgOrganizationUnmanagedApplicationsRouteRouteWithChildren,
    OrgOrganizationManagedApplicationsRoute: OrgOrganizationManagedApplicationsRoute,
    OrgOrganizationIndexRoute: OrgOrganizationIndexRoute
};
const OrgOrganizationRouteRouteWithChildren = OrgOrganizationRouteRoute._addFileChildren(OrgOrganizationRouteRouteChildren);
const OrgRouteRouteChildren = {
    OrgOrganizationRouteRoute: OrgOrganizationRouteRouteWithChildren
};
const OrgRouteRouteWithChildren = OrgRouteRoute._addFileChildren(OrgRouteRouteChildren);
const ProfileRouteChildren = {
    ProfileIndexRoute: ProfileIndexRoute,
    ProfileSettingsEmailSettingsRoute: ProfileSettingsEmailSettingsRoute,
    ProfileUsernameIndexRoute: ProfileUsernameIndexRoute,
    ProfileSettingsIndexRoute: ProfileSettingsIndexRoute,
    ProfileSettingsUserTokensUsertokenRoute: ProfileSettingsUserTokensUsertokenRoute,
    ProfileSettingsUserTokensGenerateRoute: ProfileSettingsUserTokensGenerateRoute,
    ProfileSettingsUserTokensIndexRoute: ProfileSettingsUserTokensIndexRoute
};
const ProfileRouteWithChildren = ProfileRoute._addFileChildren(ProfileRouteChildren);
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    OrgRouteRoute: OrgRouteRouteWithChildren,
    R403Route: R403Route,
    LoginRoute: LoginRoute,
    ProfileRoute: ProfileRouteWithChildren,
    AuthCallbackRoute: AuthCallbackRoute
};
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)._addFileTypes();
